import { Button } from 'antd';
import { LineOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

export const sectionBreakCommand = ({ editor, range }) =>
  range
    ? editor.chain().focus().deleteRange(range).insertContent('<hr>').run()
    : editor.chain().focus().insertContent('<hr>').run();

const SectionBreak = ({ editor, showLabel = false, indicateActive = true, isExtension = false }) => {
  return (
    <Button
      className={`editor-toolbar-btn-container ${indicateActive && editor.isActive('blockquote') ? '!bg-slate-100 text-black' : '!bg-transparent'}`}
      icon={<LineOutlined className="text-gray-800 text-xs" />}
      onClick={isExtension ? () => {} : () => sectionBreakCommand({ editor })}
      size="small"
      type="text"
    >
      {showLabel && (
        <div className="editor-toolbar-btn-label">
          <FormattedMessage id="SECTION_BREAK" defaultMessage="Section break" />
        </div>
      )}
    </Button>
  );
};

export default SectionBreak;
